import script from "./DownloadSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadSection.vue?vue&type=script&setup=true&lang=js"

import "./DownloadSection.vue?vue&type=style&index=0&id=68ad8528&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ad8528"]])

export default __exports__